var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0765 0.936487C14.7014 0.551449 14.1462 0.408003 13.6284 0.558998L1.556 4.06964C1.00977 4.22139 0.622615 4.65702 0.518323 5.21041C0.411779 5.77363 0.783931 6.48859 1.27013 6.78756L5.04493 9.10761C5.43208 9.34542 5.93179 9.28578 6.25217 8.96265L10.5747 4.61323C10.7923 4.38673 11.1524 4.38673 11.37 4.61323C11.5876 4.83217 11.5876 5.18701 11.37 5.4135L7.03999 9.76368C6.71886 10.0861 6.65884 10.5881 6.89518 10.9777L9.20163 14.7903C9.47174 15.2433 9.93693 15.5 10.4471 15.5C10.5072 15.5 10.5747 15.5 10.6347 15.4924C11.22 15.417 11.6851 15.0168 11.8577 14.4506L15.4367 2.39359C15.5942 1.88021 15.4517 1.32153 15.0765 0.936487Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 8,
    y1: 0.5,
    x2: 8,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ECDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B8E86"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.cc7ca775dc61d552de1c3472ebfdd2fb.svg";
export { ForwardRef as ReactComponent };